import React, { useState, useEffect } from 'react';
import { NavLink, BrowserRouter as Router, Route, Routes, Link, Navigate, useLocation } from 'react-router-dom';
import './components/Home/App.css';
import ScrollToTop from './components/Home/ScrollToTop';

import CoverImage from './components/Home/CoverImage';
import Gallery from './components/Home/Gallery';
import Footer from './components/Home/Footer';
import Home from './components/Home/Home';
import Wedding from './components/Home/Wedding';
import Special from './components/Home/Special';
import Dayouting from './components/Home/Dayouting';
import Preshoot from './components/Home/Preshoot';
import Accomadation from './components/Home/Accomadation';
import Awrudhu from './components/Home/Awrudhu';
import BYOC from './components/Home/BYOC';

import VedioGallery from './components/Home/VedioGallery';

import About from './components/Home/About';
import Contact from './components/Home/Contact';
import Package from './components/Home/Package';
import Beautycoco from './components/Home/Beautycoco';
import Meal from './components/Home/Meal';
import Meal1 from './components/Home/Meal1';
import Meal3 from './components/Home/Meal3';

import ReservationForm2 from './components/Home/ReservationForm2';
import MenuTable from './components/Home/MenuTable';
import Offer from './components/Home/Offer';

import WhatsAppButton from './components/Home/WhatsAppButton';
import Loader from "./components/Home/Loader";

const App = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const location = useLocation(); // Get current route location
  const [loading, setLoading] = useState(true);

  useEffect(() => {
        const timer = setTimeout(() => {
          setLoading(false);
        }, 2000);
        return () => clearTimeout(timer);
      }, []);

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar');
      if (navbar) {
        if (window.scrollY > 0) {
          navbar.classList.add('scrolled');
        } else {
          navbar.classList.remove('scrolled');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    // Trigger handleScroll immediately to apply the effect on page load
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location.pathname]); // Re-run effect when route changes

  // Close menu when a link is clicked
  const closeMenu = () => {
    setMenuOpen(false);
  };

  // Toggle the menu
  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  // Close the menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const menu = document.querySelector('.nav-links-container');
      const hamburger = document.querySelector('.hamburger-icon');
      if (menu && !menu.contains(event.target) && !hamburger.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

   if (loading) {
      return <Loader />;
    }

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-container">
          <div className="logo-container">
            <Link to="/home">
              <img src={`${process.env.PUBLIC_URL}/images/logo.webp`}  className="logo" />
            </Link>
          </div>

          {/* Hamburger Icon */}
          <div className="hamburger-icon" onClick={toggleMenu}>
            &#9776;
          </div>

          <div className={`nav-links-container ${isMenuOpen ? 'open' : ''}`}>


            <ul className="nav-links">
              <li>
                <NavLink to="/home" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                  HOME
                </NavLink>
              </li>
              <li>
                <NavLink to="/about" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                  ABOUT
                </NavLink>
              </li>
              <li>
                              <NavLink to="/meal" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                                MEAL
                              </NavLink>
                            </li>
              <li className="dropdown">
                <NavLink to="/wedding" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                  SERVICE
                </NavLink>
                <ul className="dropdown-content">
                  <li>
                    <NavLink to="/dayouting" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                      SPEND THE DAY
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/wedding" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                      WEDDING EVENT
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/special" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                      SPECIAL EVENTS
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/awrudhu" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                      AWRUDHU EVENTS
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/byoc" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                      BYOC
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/preshoot" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                      PHOTO SHOOT
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/accomadation" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                      ACCOMMODATION
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink to="/package" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                  PACKAGE
                </NavLink>
              </li>
              <li>
                <NavLink to="/galleries" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                  GALLERY
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                  CONTACT
                </NavLink>
              </li>
            </ul>
            {/* Order Online button */}
          </div>
        </div>
      </nav>

      <main className="container mt-4">
        <Routes>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/cover" element={<CoverImage />} />
          <Route path="/home" element={<Home />} />
          <Route path="/galleries" element={<Gallery />} />
          <Route path="/footer" element={<Footer />} />
          <Route path="/menutable" element={<MenuTable />} />
          <Route path="/offer" element={<Offer />} />
          <Route path="/wedding" element={<Wedding />} />
          <Route path="/special" element={<Special />} />
          <Route path="/dayouting" element={<Dayouting />} />
          <Route path="/preshoot" element={<Preshoot />} />
          <Route path="/accomadation" element={<Accomadation />} />
          <Route path="/about" element={<About />} />
          <Route path="/package" element={<Package />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/awrudhu" element={<Awrudhu />} />
          <Route path="/byoc" element={<BYOC />} />
          <Route path="/booking" element={<ReservationForm2 />} />
          <Route path="/meal" element={<Meal />} />

          {/* Catch-all route */}
          <Route path="*" element={<Navigate to="/home" />} />
        </Routes>
       <WhatsAppButton />
      </main>
    </div>
  );
};

const AppWrapper = () => (
  <Router>
    <ScrollToTop />
    <App />
  </Router>
);

export default AppWrapper;
